const mixin = ({
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    onRefresh: function () {
      this.$router.push({ path: '/404' })
    }
  },
  watch: {
    status: {
      // Verifica alterações no objeto status
      deep: true,
      handler (after, before) {
        // Erro de token inválido
        if (after.statusCode === 401) {
          this.dialogVisible = true
        }

        const title = {
          'success': 'Sucesso!',
          'error': 'Erro!',
          'warning': 'Atenção!',
          'info': 'Informação'
        }

        // Verifica o tipo do status => mutation.type
        switch (after.type) {
          case 'CONTEXTO_SUCCESS':
            this.$router.push({ name: 'FormLogin' })
            break
          case 'LOGIN_SUCCESS':
            this.$router.push({ name: 'FormSelecionaOperadora' })
            break
          case 'SELECIONA_OPERADORA_SUCCESS':
            this.$router.push({ name: 'Home' })
            break
          case 'ESQUECI_SENHA_SUCCESS':
            this.$root.$emit('email-sent', {
              status: true,
              message: after.message
            })
            after.message = 'E-mail enviado com sucesso!'
            break
          case 'ESQUECI_SENHA_FAILURE':
            this.$root.$emit('email-sent', {
              status: false,
              message: after.message
            })
            break
          case 'LOGOUT_SUCCESS':
            this.$router.push({ name: 'FormValidaContexto' })
            break
          case 'RECUPERA_SENHA_SUCCESS':
            this.$router.push({ name: 'FormLogin' })
        }

        // Mensagem de Successo/Erro
        const type = after && after.type ? after.type.split('_') : ''
        if (after.message && type.indexOf('SUCCESS') === -1) {
          this.$notify[(after.status ? 'success' : 'error')]({
            title: title[(after.status ? 'success' : 'error')],
            dangerouslyUseHTMLString: true,
            message: `${after.message} <br><small>${this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</small>`,
            showClose: true,
            position: 'bottom',
            duration: 2000,
            customClass: `el-notification-${(after.status ? 'success' : 'error')}`
          })
        }

        // critical
        if (after.critical) {
          after.critical.map(item => {
            setTimeout(() => {
              this.$notify[(item.type)]({
                title: title[item.type],
                dangerouslyUseHTMLString: true,
                message: `${item.message} <br><small>${this.$moment(new Date()).format('DD/MM/YYYY HH:mm:ss')}</small>`,
                showClose: true,
                position: 'bottom',
                duration: 2000,
                customClass: `el-notification-${item.type}`
              })
            }, 1)
          })
        }

        if (after.statusCode === 401) {
          this.$router.push({ name: 'FormLogin' })
        }

        this.$store.commit('status/UPDATE_REQUEST_STATUS', {})
      }
    }
  }
})

export default mixin
